/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';

import { resetCheckout, startBuyNowProcess } from '../../../redux/slices/checkoutSlice';

import styles from './ErrorBoundary.module.scss';

class BuyNowErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch() {
    // You can also log the error to an error reporting service
  }

  onPaymentRetry() {
    const { courseInfo, dispatch } = this.props;

    dispatch(resetCheckout());
    dispatch(startBuyNowProcess(courseInfo));
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className={styles.wrapper}>
        <div className={styles.errorWrapper}>
          <div className={styles.paymentIssueDetails}>
            <h4>Payment Error!</h4>
            <p>We have Encountered some error while processing the payment.</p>
          </div>

          <button type="button" className={styles.retryPaymentBtn} onClick={this.onPaymentRetry}>
            <FontAwesomeIcon icon={faRotateRight} />
            <span>Retry Payment</span>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  courseInfo: state.checkout.currentCourse,
});

export default connect(mapStateToProps)(BuyNowErrorBoundary);
